import { Injectable } from '@angular/core';
import { ContentService } from '../../services/content.service';
import { InfoItem } from '@common/components/info/info.component.base';
import { ItemsList } from '@common/components/items-list/items-list-component';
import { filter, map } from 'rxjs/operators';
import { Content } from '@common/model/content';

@Injectable(
    { providedIn: 'root' }
)
export class CmsInfoItemsProvider {

    defaultMainKey = 'more-information-items';
    infoItemPrefix = 'info-item-';
    urlSuffix = '-url';

    constructor(private content: ContentService) {
    }

    public GetItems(suffix: string, doNotUseCmsForKeys?: Array<string>): InfoItem[] {
        return this.GetItemsWithMainKey(this.defaultMainKey, suffix, doNotUseCmsForKeys);
    }

    public GetItemsWithMainKey(mainKey: string, suffix: string, doNotUseCmsForKeys?: Array<string>): InfoItem[] {
        let result: InfoItem[];
        const items = new ItemsList(mainKey + (suffix ? '-' + suffix : ''));

        items.getItemKeys(this.content).pipe(
            filter(list => !!list),
            map(list => {
                return list.map(
                    ii => {
                        const overrideUrl = this.infoItemPrefix + ii + this.urlSuffix;
                        let overridenUrl: Content;
                        this.content.get(overrideUrl).subscribe(c => overridenUrl = c);
                        const useCmsValue = doNotUseCmsForKeys ? doNotUseCmsForKeys.indexOf(ii) === -1 : true;
                        return new InfoItem(ii, useCmsValue, 0, overridenUrl ? overridenUrl.value : null);
                    }
                );
            })
        ).subscribe(r => result = r);
        return result;
    }
}
